var Eqa = window.Eqa = window.Eqa || {};

window.Eqa.AnchorScrolling = (function() {
  function init() {
    // Only applies to home page
    if (window.location.pathname !== '/' && window.location.pathname !== '/fr/') { return; }
  
    const anchorSelector = 'header a[href*="#"]';
    const anchors = document.querySelectorAll(anchorSelector);

    anchors.forEach(a => {
      const href = a.getAttribute('href');
      const targetId = href.substring(href.indexOf('#') + 1);
      const targetEl = document.getElementById(targetId);
      const anchorTarget = targetEl && targetEl.closest('section').querySelector('.anchor-handle');
      
      // No target element?  This is treated as a regular link.
      if (!anchorTarget) { return; }
      
      a.addEventListener('click', e => {
        e.preventDefault();
        anchorTarget.scrollIntoView(true, {
          behaviour: 'smooth'
        });
      });
    }); 
  }
  
  $(init);
})(jQuery);